/**
 * Navigation is data (the family's rule): each item names its label key, its address and who sees it. The routes behind
 * them are in App.tsx (BUILT_ROUTES); src/__tests__/nav.test.ts fails on an item whose address has no route.
 */

import type { MessageKey } from '../i18n/en'
import type { OrgRole } from '../lib/session'

export interface NavItem {
  key: MessageKey
  to: string
  /** Who sees the item; everyone signed in when left out. */
  roles?: OrgRole[]
}

export const NAV: readonly NavItem[] = [
  { key: 'nav.board', to: '/board' },
  { key: 'nav.myWork', to: '/my-work' },
  // P3: the Learning view; its group cells are for the organisation's members (a guest gets none).
  { key: 'nav.learning', to: '/learning', roles: ['admin', 'member'] },
  // P4a: the layers, both roll-up paths; for the organisation's members (a guest gets none).
  { key: 'nav.layers', to: '/layers', roles: ['admin', 'member'] },
  // P4a-2: the goal tree and drift (members and administrators); the dashboards (a guest has "You" only).
  { key: 'nav.heading', to: '/heading', roles: ['admin', 'member'] },
  { key: 'nav.dashboards', to: '/dashboards' },
  // P4b: the timeline, roadmap, workload and calendar (everyone: a guest sees their own projects and load).
  { key: 'nav.plans', to: '/plans' },
  // P7: the annual cycle (recurring work), asking a team through its intake form, the CSV import and templates, and the
  // privacy pack with "Download my data". A guest asks no team and imports nothing.
  { key: 'nav.wheel', to: '/plans/wheel' },
  { key: 'nav.intake', to: '/intake', roles: ['admin', 'member'] },
  { key: 'nav.import', to: '/import', roles: ['admin', 'member'] },
  // P5: family links, files brought in from and carried back to the family's products (members and administrators).
  { key: 'nav.family', to: '/family', roles: ['admin', 'member'] },
  // P6: Ask Pascal (the help search for everyone; Find for members), How Pascal works (everyone), the AI settings.
  { key: 'nav.ask', to: '/ask' },
  { key: 'nav.how', to: '/how' },
  { key: 'nav.units', to: '/org/units' },
  { key: 'nav.people', to: '/org/people', roles: ['admin', 'member'] },
  { key: 'nav.fourEyes', to: '/org/four-eyes', roles: ['admin', 'member'] },
  { key: 'nav.ai', to: '/org/ai', roles: ['admin', 'member'] },
  { key: 'nav.privacyPack', to: '/privacy/pack' },
]

export function navFor(role: OrgRole | null): NavItem[] {
  return NAV.filter((i) => !i.roles || (role !== null && i.roles.includes(role)))
}
